// extracted by mini-css-extract-plugin
export default {"scottflixBody":"ScottflixBodyNew_scottflixBody__IzW7S"};